(this["webpackJsonphue-interactive-visualizations"] = this["webpackJsonphue-interactive-visualizations"] || []).push([[0], {
    119 : function(e, t, n) {
        e.exports = {
            actionText: "lightmi_app_actionText",
            attention: "lightmi_app_attention",
            "grow-shrink": "lightmi_app_grow-shrink"
        }
    },
    120 : function(e, t, n) {
        e.exports = {
            muteButton: "lightmi_app_muteButton",
            muteButtonDisabled: "lightmi_app_muteButton_muteButtonDisabled"
        }
    },
    121 : function(e, t, n) {
        e.exports = {
            playButton: "lightmi_app_playButton",
            playButtonDisabled: "lightmi_app_playButton_playButtonDisabled"
        }
    },
    122 : function(e, t, n) {
        e.exports = {
            switch: "lightmi_app_switch",
            slider: "lightmi_app_slider"
        }
    },
    18 : function(e, t, n) {
        e.exports = {
            app: "lightmi_app",
            background: "lightmi_app_background",
            foreground: "lightmi_app_foreground",
            foregroundInner: "lightmi_app_foregroundInner",
            selector: "lightmi_app_selector",
            layout: "lightmi_app_layout",
            textVisible: "lightmi_app_textVisible",
            textContainer: "lightmi_app_textContainer",
            textHidden: "lightmi_app_textHidden",
            controlVisible: "lightmi_app_controlVisible",
            interactionContainer: "lightmi_app_interactionContainer",
            callOutBox: "lightmi_app_callOutBox",
            callOut: "lightmi_app_callOut",
            fadeOutCallOut: "lightmi_app_fadeOutCallOut lightmi_app_callOut",
            callOutAbs: "lightmi_app_callOutAbs lightmi_app_callOut",
            fadeOutCallOutAbs: "lightmi_app_fadeOutCallOutAbs lightmi_app_callOut",
            isFallBack: "lightmi_app__isFallBack"
        }
    },
    188 : function(e, t, n) {
        e.exports = {
            actionText: "lightmi_app_actionText_2"
        }
    },
    189 : function(e, t, n) {
        e.exports = {
            backgroundImage: "lightmi_app_backgroundImage"
        }
    },
    190 : function(e, t, n) {
        e.exports = {
            debugInfo: "lightmi_app_debugInfo"
        }
    },
    193 : function(e, t, n) {
        e.exports = n(392)
    },
    388 : function(e, t, n) {},
    389 : function(e, t, n) {},
    390 : function(e, t, n) {},
    391 : function(e, t, n) {
        "use strict";
        n.r(t);
        var a = n(4),
        r = n(5),
        o = n(16),
        i = n(15),
        s = (n(390), n(0)),
        c = n.n(s),
        u = n(188),
        l = n.n(u),
        d = function(e) {
            Object(o.a)(n, e);
            var t = Object(i.a)(n);
            function n(e) {
                var r;
                return Object(a.a)(this, n),
                (r = t.call(this, e)).interval = void 0,
                r.videoElement = null,
                r.canPlayThroughListener = null,
                r.state = {
                    preloaded: !!e.videoSrc,
                    videoSrc: e.videoSrc
                },
                r
            }
            return Object(r.a)(n, [{
                key: "componentDidMount",
                value: function() {
                    this.update()
                }
            },
            {
                key: "componentDidUpdate",
                value: function() {
                    this.update()
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.removeAllEventListeners()
                }
            },
            {
                key: "update",
                value: function() {
                    var e = this;
                    this.props.videoSrc !== this.state.videoSrc && (this.props.videoSrc ? (this.setState({
                        preloaded: !1,
                        videoSrc: this.props.videoSrc
                    }), this.preloadVideoSrc(this.props.videoSrc, (function(t) {
                        t === e.props.videoSrc && e.setState({
                            preloaded: !0,
                            videoSrc: e.props.videoSrc
                        })
                    }))) : this.setState({
                        preloaded: !0,
                        videoSrc: null
                    }))
                }
            },
            {
                key: "preloadVideoSrc",
                value: function(e, t) {
                    var n = this,
                    a = !1;
                    this.removeAllEventListeners();
                    var r = document.createElement("video");
                    r.addEventListener(this.props.event, (function() {
                        a || (a = !0, t(e))
                    })),
                    this.interval = window.setInterval((function() {
                        r.readyState >= 3 && (window.clearInterval(n.interval), a || (a = !0, t(e)))
                    }), 500),
                    r.src = e,
                    r.load()
                }
            },
            {
                key: "removeAllEventListeners",
                value: function() {
                    this.videoElement && this.canPlayThroughListener && this.videoElement.removeEventListener(this.props.event, this.canPlayThroughListener),
                    this.interval && window.clearInterval(this.interval)
                }
            },
            {
                key: "render",
                value: function() {
                    var e = !(this.state.videoSrc !== this.props.videoSrc) && this.state.preloaded;
                    return this.props.render(e)
                }
            }]),
            n
        } (c.a.Component),
        p = n(23),
        h = n(40),
        f = n.n(h),
        v = function(e) {
            return function(e, t, n) {
                return c.a.createElement(c.a.Fragment, null, e.split(t).map((function(e, t) {
                    return t % 2 ? n(e, t) : e
                })))
            } (e, "**", (function(e, t) {
                return c.a.createElement("b", {
                    key: t
                },
                e)
            }))
        },
        m = function(e) {
            var t = e.input;
            return c.a.createElement(c.a.Fragment, null, v(t))
        },
        y = n(192),
        g = function(e) {
            return Object.entries(e).reduce((function(e, t) {
                var n = Object(y.a)(t, 2),
                a = n[0];
                return n[1] ? e.concat(a) : e
            }), []).join(" ")
        },
        b = function(e) {
            var t, n, a, r = e.title,
            o = e.longText,
            i = e.useIosCssAnimationFix,
            s = void 0 !== i && i,
            u = e.shortText,
            l = e.longTextStyle,
            d = e.titleStyle;
            return c.a.createElement(c.a.Fragment, null, r && c.a.createElement("h2", {
                style: d,
                className: g((t = {},
                Object(p.a)(t, f.a.title, !0), Object(p.a)(t, f.a.fixIOSIssue, s), t))
            },
            c.a.createElement(m, {
                input: r
            })), o && c.a.createElement("p", {
                style: l,
                className: g((n = {},
                Object(p.a)(n, f.a.text, !0), Object(p.a)(n, f.a.longText, !0), Object(p.a)(n, f.a.fixIOSIssue, s), n))
            },
            o), u && c.a.createElement("p", {
                className: g((a = {},
                Object(p.a)(a, f.a.text, !0), Object(p.a)(a, f.a.shortText, !0), Object(p.a)(a, f.a.fixIOSIssue, s), a))
            },
            u))
        },
        S = n(119),
        w = n.n(S),
        _ = function(e) {
            var t, n = e.className,
            a = void 0 === n ? "": n,
            r = e.children,
            o = e.attractAttention,
            i = void 0 !== o && o;
            return c.a.createElement("h2", {
                className: g((t = {},
                Object(p.a)(t, w.a.actionText, !0), Object(p.a)(t, a, !!a), Object(p.a)(t, w.a.attention, i), t))
            },
            r)
        },
        O = n(120),
        j = n.n(O);
        function E() {
            return (E = Object.assign ||
            function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var n = arguments[t];
                    for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a])
                }
                return e
            }).apply(this, arguments)
        }
        function k(e, t) {
            if (null == e) return {};
            var n, a, r = function(e, t) {
                if (null == e) return {};
                var n, a, r = {},
                o = Object.keys(e);
                for (a = 0; a < o.length; a++) n = o[a],
                t.indexOf(n) >= 0 || (r[n] = e[n]);
                return r
            } (e, t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                for (a = 0; a < o.length; a++) n = o[a],
                t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n])
            }
            return r
        }
        var x = c.a.createElement("path", {
            d: "M3.66 6.79l2.383-2.11v3.779zm4.023-5.192c.37-.1.53.141.456.485L1.065 8.545c-.27-.068-.373-.209-.3-.428L2.52 6.49S.98 6.095 1.022 5.096c.043-.998 1.54-1.344 1.54-1.344v1.344h.642V3.71L6.043 1.7v1.283z"
        }),
        I = function(e) {
            var t = e.svgRef,
            n = e.title,
            a = k(e, ["svgRef", "title"]);
            return c.a.createElement("svg", E({
                viewBox: "0 0 10.583 10.583",
                height: 40,
                width: 40,
                ref: t
            },
            a), n ? c.a.createElement("title", null, n) : null, x)
        },
        T = c.a.forwardRef((function(e, t) {
            return c.a.createElement(I, E({
                svgRef: t
            },
            e))
        }));
        n.p;
        function L() {
            return (L = Object.assign ||
            function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var n = arguments[t];
                    for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a])
                }
                return e
            }).apply(this, arguments)
        }
        function P(e, t) {
            if (null == e) return {};
            var n, a, r = function(e, t) {
                if (null == e) return {};
                var n, a, r = {},
                o = Object.keys(e);
                for (a = 0; a < o.length; a++) n = o[a],
                t.indexOf(n) >= 0 || (r[n] = e[n]);
                return r
            } (e, t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                for (a = 0; a < o.length; a++) n = o[a],
                t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n])
            }
            return r
        }
        var C = c.a.createElement("path", {
            d: "M6.043 1.698L3.233 3.71v1.387h-.685V3.752s-1.484.346-1.526 1.344c.008.831.98 1.263 1.526 1.374h.685c.92.687 1.87 1.33 2.81 1.99zm2.332 1.326c-.136-.004-.24.057-.223.357 1.124 1.155.823 2.325 0 3.5.023.17-.008.366.367.359.9-1.36 1.438-2.735 0-4.196a.937.937 0 00-.144-.02zm-.882.876c-.13.01-.2.144-.18.266.398.605.322 1.187 0 1.754-.063.303.286.289.327.243.418-.695.641-1.418 0-2.226a.268.268 0 00-.147-.037z"
        }),
        B = function(e) {
            var t = e.svgRef,
            n = e.title,
            a = P(e, ["svgRef", "title"]);
            return c.a.createElement("svg", L({
                viewBox: "0 0 10.583 10.583",
                height: 40,
                width: 40,
                ref: t
            },
            a), n ? c.a.createElement("title", null, n) : null, C)
        },
        V = c.a.forwardRef((function(e, t) {
            return c.a.createElement(B, L({
                svgRef: t
            },
            e))
        })),
        R = (n.p,
        function(e) {
            return [j.a.muteButton, !e.enabled && j.a.muteButtonDisabled].filter(Boolean).join(" ")
        }),
        N = function(e) {
            var t = e.muted,
            n = e.onToggle,
            a = e.enabled,
            r = {
                muted: t,
                onToggle: n,
                enabled: void 0 === a || a
            };
            return c.a.createElement("div", {
                className: R(r),
                onClick: function() {
                    n()
                }
            },
            t ? c.a.createElement(T, null) : c.a.createElement(V, null))
        },
        F = n(121),
        M = n.n(F);
        function A() {
            return (A = Object.assign ||
            function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var n = arguments[t];
                    for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a])
                }
                return e
            }).apply(this, arguments)
        }
        function D(e, t) {
            if (null == e) return {};
            var n, a, r = function(e, t) {
                if (null == e) return {};
                var n, a, r = {},
                o = Object.keys(e);
                for (a = 0; a < o.length; a++) n = o[a],
                t.indexOf(n) >= 0 || (r[n] = e[n]);
                return r
            } (e, t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                for (a = 0; a < o.length; a++) n = o[a],
                t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n])
            }
            return r
        }
        var H = c.a.createElement("path", {
            d: "M7.98 1.31c-.11.001-1.027.01-1.11.009-.224-.002-.195.255-.195.255V8.15c.002.066-.08.264.194.26.131-.002 1.112 0 1.112 0 .267.001.229-.26.229-.26V1.574s.064-.263-.23-.263zm-3.52 0c-.111.001-1.028.01-1.112.009-.224-.002-.194.255-.194.255V8.15c.002.066-.08.264.194.26.131-.002 1.112 0 1.112 0 .267.001.229-.26.229-.26V1.574s.064-.263-.23-.263z"
        }),
        W = function(e) {
            var t = e.svgRef,
            n = e.title,
            a = D(e, ["svgRef", "title"]);
            return c.a.createElement("svg", A({
                viewBox: "0 0 10.583 10.583",
                height: 40,
                width: 40,
                ref: t
            },
            a), n ? c.a.createElement("title", null, n) : null, H)
        },
        z = c.a.forwardRef((function(e, t) {
            return c.a.createElement(W, A({
                svgRef: t
            },
            e))
        }));
        n.p;
        function U() {
            return (U = Object.assign ||
            function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var n = arguments[t];
                    for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a])
                }
                return e
            }).apply(this, arguments)
        }
        function Y(e, t) {
            if (null == e) return {};
            var n, a, r = function(e, t) {
                if (null == e) return {};
                var n, a, r = {},
                o = Object.keys(e);
                for (a = 0; a < o.length; a++) n = o[a],
                t.indexOf(n) >= 0 || (r[n] = e[n]);
                return r
            } (e, t);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                for (a = 0; a < o.length; a++) n = o[a],
                t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n])
            }
            return r
        }
        var X, G = c.a.createElement("path", {
            d: "M3.367 1.31a.2.2 0 00-.213.2v6.71a.2.2 0 00.088.165.267.267 0 00.188.039c1.637-1.066 3.288-2.306 4.707-3.356a.2.2 0 00.002-.32c-1.521-1.175-3.187-2.337-4.666-3.4a.2.2 0 00-.106-.037z"
        }),
        K = function(e) {
            var t = e.svgRef,
            n = e.title,
            a = Y(e, ["svgRef", "title"]);
            return c.a.createElement("svg", U({
                viewBox: "0 0 10.583 10.583",
                height: 40,
                width: 40,
                ref: t
            },
            a), n ? c.a.createElement("title", null, n) : null, G)
        },
        J = c.a.forwardRef((function(e, t) {
            return c.a.createElement(K, U({
                svgRef: t
            },
            e))
        })),
        Z = (n.p,
        function(e) {
            return [M.a.playButton, !e.enabled && M.a.playButtonDisabled].filter(Boolean).join(" ")
        }),
        Q = function(e) {
            var t = e.paused,
            n = e.onToggle,
            a = e.enabled,
            r = {
                paused: t,
                onToggle: n,
                enabled: void 0 === a || a
            };
            return c.a.createElement("div", {
                className: Z(r),
                onClick: function() {
                    n()
                }
            },
            t ? c.a.createElement(J, null) : c.a.createElement(z, null))
        },
        $ = function() {
            function e(t) {
                Object(a.a)(this, e),
                this.sources = void 0,
                this.sources = t
            }
            return Object(r.a)(e, null, [{
                key: "fromSources",
                value: function(t) {
                    return new e(t)
                }
            },
            {
                key: "sourceTypeFromSrc",
                value: function(e) {
                    var t = e.split("."),
                    n = t[t.length - 1].toLowerCase();
                    return "video/".concat(n)
                }
            }]),
            Object(r.a)(e, [{
                key: "sourcesForWidth",
                value: function(e) {
                    var t = this;
                    return this.sortSources(this.types.map((function(n) {
                        return t.sourceForWidthAndType(e, n)
                    })))
                }
            },
            {
                key: "firstPlayableSourceForWidth",
                value: function(t) {
                    var n = this.sourcesForWidth(t),
                    a = document.createElement("video"),
                    r = n.find((function(t) {
                        return a.canPlayType(e.sourceTypeFromSrc(t.src))
                    }));
                    return r || null
                }
            },
            {
                key: "sortSources",
                value: function(e) {
                    var t = this;
                    return e.sort((function(e, n) {
                        return t.sources.findIndex((function(t) {
                            return t === e
                        })) - t.sources.findIndex((function(e) {
                            return e === n
                        }))
                    }))
                }
            },
            {
                key: "sourceForWidthAndType",
                value: function(e, t) {
                    return this.sourcesForType(t).reduce((function(t, n) {
                        return e <= n.width && n.width < t.width ? n: t
                    }), this.widestSourceForType(t))
                }
            },
            {
                key: "widestSourceForType",
                value: function(e) {
                    var t = this.sourcesForType(e);
                    if (0 === t.length) throw new Error("No source with type ".concat(e, " found"));
                    return t.reduce((function(e, t) {
                        return t.width > e.width ? t: e
                    }), t[0])
                }
            },
            {
                key: "sourcesForType",
                value: function(t) {
                    return this.sources.filter((function(n) {
                        return e.sourceTypeFromSrc(n.src) === t
                    }))
                }
            },
            {
                key: "types",
                get: function() {
                    return this.sources.reduce((function(t, n) {
                        var a = e.sourceTypeFromSrc(n.src);
                        return t.findIndex((function(e) {
                            return e === a
                        })) > -1 ? t: t.concat(a)
                    }), [])
                }
            }]),
            e
        } (),
        q = n(71),
        ee = function() {
            function e() {
                Object(a.a)(this, e)
            }
            return Object(r.a)(e, null, [{
                key: "getURLParameterByName",
                value: function(e) {
                    var t = window.location.href;
                    e = e.replace(/[[\]]/g, "\\$&");
                    var n = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)").exec(t);
                    return n ? n[2] ? decodeURIComponent(n[2].replace(/\+/g, " ")) : "": null
                }
            },
            {
                key: "debug",
                get: function() {
                    return "true" === e.getURLParameterByName("debug")
                }
            },
            {
                key: "simulateUnsupportedBrowser",
                get: function() {
                    return "true" === e.getURLParameterByName("simulateUnsupportedBrowser")
                }
            }]),
            e
        } (),
        te = [function(e) {
            var t = e.getBrowser();
            return "IE" === t.name && t.major && parseInt(t.major) <= 11
        },
        function(e) {
            var t = e.getBrowser();
            return "Edge" === t.name && t.major && parseInt(t.major) <= 18
        },
        function(e) {
            var t = e.getOS(),
            n = t.version ? parseInt(t.version.split(".")[0]) : null;
            return "iOS" === t.name && n && n <= 11
        },
        function(e) {
            var t = e.getBrowser();
            return "Safari" === t.name && t.major && parseInt(t.major) <= 11
        },
        function(e) {
            var t = e.getBrowser();
            return "Opera" === t.name && t.major && parseInt(t.major) <= 37
        },
        function(e) {
            return "Windows Phone" === e.getOS().name
        },
        function(e) {
            return "UCBrowser" === e.getBrowser().name
        }],
        ne = n(189),
        ae = n.n(ne),
        re = n(18),
        oe = n.n(re); !
        function(e) {
            e[e.Text = 1] = "Text",
            e[e.Control = 2] = "Control",
            e[e.Both = 3] = "Both"
        } (X || (X = {}));
        var ie, se = function() {
            for (var e = arguments.length,
            t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
            return t.filter(Boolean).join(" ")
        },
        ce = function(e) {
            return se(oe.a.layout, e === X.Both ? oe.a.bothElementsVisible: e & X.Text ? oe.a.textVisible: oe.a.textHidden, e & X.Control ? oe.a.controlVisible: oe.a.controlHidden)
        },
        ue = function(e) {
            var t = e.visibility,
            n = e.onClick,
            a = e.header,
            r = e.interactionControl,
            o = e.settings,
            i = e.selector,
            s = e.callToAction,
            u = e.callToReveal,
            l = e.background,
            d = e.showInteractionClassName,
            p = e.hideInteractionClassName,
            h = e.isFallback,
            f = t & X.Control && u,
            v = t & X.Control;
            return c.a.createElement("div", {
                className: "".concat(oe.a.app, " ").concat(h ? oe.a.isFallBack: "")
            },
            c.a.createElement("div", {
                className: oe.a.foreground
            },
            c.a.createElement("div", {
                className: oe.a.foregroundInner
            },
            i && c.a.createElement("div", {
                className: oe.a.selector
            },
            i), o, c.a.createElement("div", {
                className: se(ce(t), f ? d: p),
                onClick: n
            },
            c.a.createElement("div", {
                className: oe.a.textContainer
            },
            a), c.a.createElement("div", {
                className: oe.a.interactionContainer
            },
            c.a.createElement("div", {
                className: oe.a.callOutBox
            },
            c.a.createElement("div", {
                className: f ? oe.a.fadeOutCallOutAbs: oe.a.callOutAbs
            },
            u), c.a.createElement("div", {
                className: v ? oe.a.callOut: oe.a.fadeOutCallOut
            },
            s)), r)))), c.a.createElement("div", {
                className: oe.a.background
            },
            l))
        },
        le = function(e) {
            return c.a.createElement(ue, {
                visibility: X.Text,
                isFallback: !0,
                header: c.a.createElement(b, {
                    title: e.title,
                    shortText: e.shortText,
                    longText: e.longText
                }),
                background: c.a.createElement("img", {
                    className: ae.a.backgroundImage,
                    src: e.image,
                    alt: ""
                })
            })
        },
        de = n(3),
        pe = n(190),
        he = n.n(pe),
        fe = function(e) {
            var t = (new q.UAParser).getOS().version;
            return c.a.createElement("div", {
                className: he.a.debugInfo
            },
            c.a.createElement("textarea", {
                onFocus: function(e) {
                    e.target.select()
                }
            },
            JSON.stringify(Object(de.a)(Object(de.a)({},
            (new q.UAParser).getResult()), {},
            {
                osMajorVersion: t ? parseInt(t.split(".")[0]) : "?"
            }))))
        }; !
        function(e) {
            e.Playing = "playing",
            e.Paused = "paused",
            e.Stopped = "stopped",
            e.Loading = "loading"
        } (ie || (ie = {}));
        var ve = ie,
        me = n(90),
        ye = n.n(me),
        ge = n(72),
        be = function(e) {
            return e.sources.reduce((function(e, t) {
                return e + "".concat(e.length > 0 ? ", ": "").concat(t.src, " ").concat(t.width, "w")
            }), "")
        },
        Se = function(e) {
            return function(e) {
                return e ? e.src: ""
            } (function(e) {
                return 0 === e.sources.length ? null: e.sources.reduce((function(e, t) {
                    return t.width > e.width ? t: e
                }), e.sources[0])
            } (e))
        },
        we = function(e) {
            return c.a.createElement("img", Object.assign({},
            function(e) {
                e.sources;
                return Object(ge.a)(e, ["sources"])
            } (e), {
                alt: e.alt,
                srcSet: be(e),
                src: Se(e)
            }))
        },
        _e = function(e) {
            Object(o.a)(n, e);
            var t = Object(i.a)(n);
            function n() {
                return Object(a.a)(this, n),
                t.apply(this, arguments)
            }
            return Object(r.a)(n, [{
                key: "render",
                value: function() {
                    var e = this;
                    return c.a.createElement("video", Object.assign({},
                    this.htmlVideoProps, {
                        ref: this.props.videoRef
                    }), this.sourcesForWidth(this.props.physicalPixelWidth).map((function(t) {
                        return c.a.createElement("source", Object.assign({},
                        e.htmlSourceProps(t), {
                            key: e.key(t),
                            type: $.sourceTypeFromSrc(t.src)
                        }))
                    })))
                }
            },
            {
                key: "sourcesForWidth",
                value: function(e) {
                    return $.fromSources(this.props.sources).sourcesForWidth(e)
                }
            },
            {
                key: "htmlSourceProps",
                value: function(e) {
                    e.width;
                    return Object(ge.a)(e, ["width"])
                }
            },
            {
                key: "key",
                value: function(e) {
                    return $.sourceTypeFromSrc(e.src) + "." + e.width
                }
            },
            {
                key: "htmlVideoProps",
                get: function() {
                    var e = this.props;
                    e.sources,
                    e.physicalPixelWidth,
                    e.videoRef;
                    return Object(ge.a)(e, ["sources", "physicalPixelWidth", "videoRef"])
                }
            }]),
            n
        } (c.a.Component),
        Oe = function(e) {
            Object(o.a)(n, e);
            var t = Object(i.a)(n);
            function n(e) {
                var r;
                return Object(a.a)(this, n),
                (r = t.call(this, e)).video = void 0,
                r.video = c.a.createRef(),
                r
            }
            return Object(r.a)(n, [{
                key: "componentDidMount",
                value: function() {
                    this.update()
                }
            },
            {
                key: "componentDidUpdate",
                value: function() {
                    this.update()
                }
            },
            {
                key: "update",
                value: function() {
                    this.video.current && (this.props.videoState === ve.Paused ? this.video.current.pause() : this.props.videoState === ve.Playing ? this.video.current.play() : this.props.videoState === ve.Stopped && (this.video.current.currentTime = 0, this.video.current.pause()))
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    return c.a.createElement("div", {
                        className: ye.a.container
                    },
                    "video" === e.props.mediaItem.type ? c.a.createElement(_e, {
                        playsInline: !0,
                        preload: e.props.preload,
                        videoRef: e.video,
                        autoPlay: !!e.props.autoPlay,
                        loop: !0,
                        muted: e.props.muted,
                        className: ye.a.mediaItem,
                        style: e.props.style,
                        key: e.props.mediaItem.props.src,
                        physicalPixelWidth: e.props.width,
                        sources: [{
                            src: e.props.mediaItem.props.src,
                            width: 1920
                        }]
                    }) : c.a.createElement(we, Object.assign({},
                    e.props.mediaItem.props, {
                        className: ye.a.mediaItem,
                        style: e.props.style
                    })))
                }
            }]),
            n
        } (c.a.Component),
        je = n(89),
        Ee = function(e) {
            Object(o.a)(n, e);
            var t = Object(i.a)(n);
            function n(e) {
                var r;
                return Object(a.a)(this, n),
                (r = t.call(this, e)).resizeEventListener = void 0,
                r.state = {
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                },
                r.resizeEventListener = r.updateDimensions.bind(Object(je.a)(r)),
                r
            }
            return Object(r.a)(n, [{
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    window.addEventListener("resize", this.resizeEventListener),
                    this.updateDimensions(),
                    window.setTimeout((function() {
                        e.updateDimensions()
                    }), 500)
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    window.removeEventListener("resize", this.resizeEventListener)
                }
            },
            {
                key: "updateDimensions",
                value: function() {
                    this.setState({
                        windowWidth: window.innerWidth,
                        windowHeight: window.innerHeight
                    })
                }
            },
            {
                key: "render",
                value: function() {
                    return this.props.render(this.state.windowWidth, this.state.windowHeight)
                }
            }]),
            n
        } (c.a.Component),
        ke = function(e) {
            var t = e.videoState,
            n = e.mediaItem,
            a = e.muted,
            r = e.autoPlay,
            o = void 0 === r || r,
            i = e.preload,
            s = void 0 === i ? "": i,
            u = e.cropX,
            l = void 0 === u ? .5 : u,
            d = e.cropY,
            p = void 0 === d ? .5 : d;
            return c.a.createElement(Ee, {
                render: function(e) {
                    return c.a.createElement(Oe, {
                        videoState: t,
                        mediaItem: n,
                        muted: a,
                        autoPlay: o,
                        preload: s,
                        style: {
                            objectPosition: "".concat(100 * l, "% ").concat(100 * p, "%")
                        },
                        width: e
                    })
                }
            })
        },
        xe = function() {
            function e(t) {
                Object(a.a)(this, e),
                this._initialState = void 0,
                this._newState = void 0,
                this._initialState = t,
                this._newState = t
            }
            return Object(r.a)(e, [{
                key: "newState",
                get: function() {
                    return this._newState
                }
            }], [{
                key: "initialState",
                value: function(e) {
                    return {
                        layers: [{
                            props: e,
                            id: 1
                        }]
                    }
                }
            },
            {
                key: "propsUpdated",
                value: function(t, n) {
                    return new e(n).handlePropsUpdated(t)
                }
            }]),
            Object(r.a)(e, [{
                key: "handlePropsUpdated",
                value: function(e) {
                    return this.sourceHasChanged(e) ? this.addNewLayer(e).discardOldLayers().newState: this.updateTopLayer(e).newState
                }
            },
            {
                key: "sourceHasChanged",
                value: function(e) {
                    return this._initialState.layers[this._initialState.layers.length - 1].props.mediaItem.id !== e.mediaItem.id
                }
            },
            {
                key: "addNewLayer",
                value: function(e) {
                    var t = this._newState.layers[this._newState.layers.length - 1];
                    return this._newState = Object(de.a)(Object(de.a)({},
                    this._newState), {},
                    {
                        layers: [Object(de.a)(Object(de.a)({},
                        t), {},
                        {
                            props: Object(de.a)(Object(de.a)({},
                            t.props), {},
                            {
                                muted: !0
                            })
                        }), {
                            id: t.id + 1,
                            props: Object(de.a)({},
                            e)
                        }]
                    }),
                    this
                }
            },
            {
                key: "discardOldLayers",
                value: function() {
                    return this._newState = Object(de.a)(Object(de.a)({},
                    this._newState), {},
                    {
                        layers: this._newState.layers.slice(this._newState.layers.length - 2, this._newState.layers.length + 1)
                    }),
                    this
                }
            },
            {
                key: "updateTopLayer",
                value: function(e) {
                    var t = this._newState.layers[this._newState.layers.length - 1];
                    return this._newState = Object(de.a)(Object(de.a)({},
                    this._newState), {},
                    {
                        layers: this._newState.layers.map((function(n) {
                            return n.id === t.id ? Object(de.a)(Object(de.a)({},
                            n), {},
                            {
                                props: Object(de.a)({},
                                e)
                            }) : n
                        }))
                    }),
                    this
                }
            }]),
            e
        } (),
        Ie = n(73),
        Te = n.n(Ie),
        Le = function(e) {
            Object(o.a)(n, e);
            var t = Object(i.a)(n);
            function n(e) {
                var r;
                return Object(a.a)(this, n),
                (r = t.call(this, e)).state = xe.initialState(e),
                r
            }
            return Object(r.a)(n, [{
                key: "render",
                value: function() {
                    var e = this;
                    return c.a.createElement(c.a.Fragment, null, this.state.layers.map((function(t) {
                        return c.a.createElement("div", {
                            className: e.getClasses(t),
                            key: t.id
                        },
                        c.a.createElement(ke, Object.assign({},
                        t.props, {
                            cropX: e.props.cropX,
                            cropY: e.props.cropY
                        })))
                    })), c.a.createElement("div", {
                        className: this.lightMiMaskClasses
                    },
                    c.a.createElement(ke, {
                        mediaItem: {
                            id: this.props.frames.sources[0].src,
                            type: "image",
                            props: Object(de.a)({},
                            this.props.frames)
                        },
                        cropX: this.props.cropX,
                        cropY: this.props.cropY
                    })))
                }
            },
            {
                key: "getClasses",
                value: function(e) {
                    var t = this.state.layers[0].id !== e.id,
                    n = this.state.layers.length > 1 && t;
                    return [Te.a.container, n && Te.a.fadeIn].filter(Boolean).join(" ")
                }
            },
            {
                key: "lightMiMaskClasses",
                get: function() {
                    return [Te.a.lightMiLayer, this.props.lightMiEnabled && Te.a.lightMiLayerEnabled].filter(Boolean).join(" ")
                }
            }], [{
                key: "getDerivedStateFromProps",
                value: function(e, t) {
                    return xe.propsUpdated(e, t)
                }
            }]),
            n
        } (c.a.Component),
        Pe = n(52),
        Ce = n.n(Pe),
        Be = n(122),
        Ve = n.n(Be),
        Re = function(e) {
            return c.a.createElement("div", {
                className: Ve.a.
                switch
            },
            c.a.createElement("input", {
                type: "checkbox",
                checked: !!e.enabled,
                readOnly: !0,
                onChange: function() {
                    e.onToggle && e.onToggle()
                }
            }), c.a.createElement("span", {
                className: Ve.a.slider
            }))
        },
        Ne = function(e) {
            Object(o.a)(n, e);
            var t = Object(i.a)(n);
            function n(e) {
                var r;
                return Object(a.a)(this, n),
                (r = t.call(this, e)).currentTimeout = void 0,
                r.state = {
                    actualValue: e.value,
                    debouncedValue: e.value
                },
                r
            }
            return Object(r.a)(n, [{
                key: "componentDidUpdate",
                value: function() {
                    var e = this;
                    clearTimeout(this.currentTimeout),
                    this.state.actualValue !== this.props.value && this.setState({
                        actualValue: this.props.value
                    }),
                    this.state.debouncedValue !== this.props.value && (this.shouldDebounce(this.props.value) ? this.currentTimeout = window.setTimeout((function() {
                        e.setState({
                            debouncedValue: e.props.value
                        })
                    }), this.debounceTime) : this.setState({
                        debouncedValue: this.props.value
                    }))
                }
            },
            {
                key: "shouldDebounce",
                value: function(e) {
                    return void 0 === this.props.shouldDebounce || this.props.shouldDebounce(e, this.state.debouncedValue)
                }
            },
            {
                key: "render",
                value: function() {
                    return this.props.render(this.state.debouncedValue)
                }
            },
            {
                key: "debounceTime",
                get: function() {
                    return void 0 === this.props.debounceTimeMs ? 500 : this.props.debounceTimeMs
                }
            }]),
            n
        } (c.a.Component),
        Fe = function(e) {
            return c.a.createElement(Ne, {
                value: e.videoState,
                debounceTimeMs: 500,
                shouldDebounce: function(e) {
                    return e === ve.Loading
                },
                render: function(t) {
                    return e.render(t)
                }
            })
        },
        Me = function(e) {
            return [Ce.a.subtitle, (!e.lightMiEnabled || e.videoState !== ve.Playing) && Ce.a.subtitleDisabled].filter(Boolean).join(" ")
        },
        Ae = function(e) {
            return c.a.createElement("div", {
                className: Ce.a.lightmiControl,
                onClick: function() {
                    e.onToggleLightMi()
                }
            },
            c.a.createElement("div", {
                className: Ce.a.label
            },
            c.a.createElement("div", {
                className: Ce.a.title
            },
            "Sync"), c.a.createElement(Fe, {
                videoState: e.videoState,
                render: function(t) {
                    return c.a.createElement("div", {
                        className: Me(Object(de.a)(Object(de.a)({},
                        e), {},
                        {
                            videoState: t
                        }))
                    },
                    function(e) {
                        switch (e.videoState) {
                        case ve.Loading:
                            return "Loading";
                        case ve.Paused:
                        case ve.Stopped:
                            return e.lightMiEnabled ? "Ready to sync": "Off";
                        case ve.Playing:
                            return e.lightMiEnabled ? "Syncing": "Off"
                        }
                    } (Object(de.a)(Object(de.a)({},
                    e), {},
                    {
                        videoState: t
                    })))
                }
            })), c.a.createElement("div", {
                className: Ce.a.toggleContainer
            },
            c.a.createElement(Re, {
                enabled: e.lightMiEnabled
            })))
        },
        De = function(e) {
            Object(o.a)(n, e);
            var t = Object(i.a)(n);
            function n(e) {
                var r;
                return Object(a.a)(this, n),
                (r = t.call(this, e)).interval = void 0,
                r.state = {
                    iframeReady: r.calculateIframeReady()
                },
                r.interval = window.setInterval((function() {
                    r.state.iframeReady ? window.clearInterval(r.interval) : r.updateIframeReady()
                }), 500),
                r
            }
            return Object(r.a)(n, [{
                key: "componentDidMount",
                value: function() {
                    window.addEventListener("resize", this.updateIframeReady.bind(this)),
                    this.updateIframeReady()
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    window.removeEventListener("resize", this.updateIframeReady.bind(this)),
                    window.clearInterval(this.interval)
                }
            },
            {
                key: "updateIframeReady",
                value: function() {
                    this.setState({
                        iframeReady: this.calculateIframeReady()
                    })
                }
            },
            {
                key: "calculateIframeReady",
                value: function() {
                    return window.innerWidth > 0 && window.innerHeight > 0
                }
            },
            {
                key: "render",
                value: function() {
                    return c.a.createElement(c.a.Fragment, null, this.state.iframeReady && this.props.children)
                }
            }]),
            n
        } (c.a.Component),
        He = function() {
            function e(t) {
                Object(a.a)(this, e),
                this.messageEventIO = void 0,
                this.messageEventIO = t
            }
            return Object(r.a)(e, [{
                key: "tag",
                value: function(e) {
                    this.messageEventIO.sendMessageToParent({
                        type: "hie_interaction",
                        name: window.name,
                        event: Object(de.a)({
                            type: e.type
                        },
                        e.props)
                    })
                }
            }]),
            e
        } (),
        We = function() {
            function e(t) {
                var n = this;
                Object(a.a)(this, e),
                this._receivedMessageEvents = void 0,
                this.callbacks = void 0,
                this.window = void 0,
                this.window = t;
                var r = t;
                this._receivedMessageEvents = r.receivedMessageEvents ? r.receivedMessageEvents: [],
                this.callbacks = [],
                t.addEventListener("message", (function(e) {
                    n._receivedMessageEvents.push(e),
                    n.callbacks.forEach((function(t) {
                        t(e)
                    }))
                }))
            }
            return Object(r.a)(e, [{
                key: "receivedMessageEvents",
                value: function() {
                    return this._receivedMessageEvents
                }
            },
            {
                key: "sendMessageToParent",
                value: function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*";
                    if(t!=='file://'){
                        this.window.parent.postMessage(e, t)
                    }

                }
            },
            {
                key: "onReceiveMessageEvent",
                value: function(e) {
                    this.callbacks.push(e)
                }
            }]),
            e
        } (),
        ze = function e() {
            Object(a.a)(this, e)
        },
        Ue = function(e) {
            Object(o.a)(n, e);
            var t = Object(i.a)(n);
            function n(e) {
                var r;
                return Object(a.a)(this, n),
                (r = t.call(this))._props = void 0,
                r._props = Object(de.a)(Object(de.a)({},
                e), {},
                {
                    name: r.cleanName(e.name)
                }),
                r
            }
            return Object(r.a)(n, [{
                key: "cleanName",
                value: function(e) {
                    return e.toLowerCase().replace(/ /g, "_")
                }
            },
            {
                key: "type",
                get: function() {
                    return "video_switch"
                }
            },
            {
                key: "props",
                get: function() {
                    return Object(de.a)(Object(de.a)({},
                    this._props), {},
                    {
                        eventString: "".concat(this._props.name, ":").concat(this._props.mode, ":button")
                    })
                }
            }]),
            n
        } (ze),
        Ye = function(e) {
            Object(o.a)(n, e);
            var t = Object(i.a)(n);
            function n(e) {
                var r;
                return Object(a.a)(this, n),
                (r = t.call(this))._props = void 0,
                r._props = e,
                r
            }
            return Object(r.a)(n, [{
                key: "type",
                get: function() {
                    return "toggle_sync"
                }
            },
            {
                key: "props",
                get: function() {
                    return Object(de.a)(Object(de.a)({},
                    this._props), {},
                    {
                        eventString: "".concat(this._props.mode, ":toggle")
                    })
                }
            }]),
            n
        } (ze),
        Xe = function(e) {
            Object(o.a)(n, e);
            var t = Object(i.a)(n);
            function n(e) {
                var r;
                return Object(a.a)(this, n),
                (r = t.call(this))._props = void 0,
                r._props = e,
                r
            }
            return Object(r.a)(n, [{
                key: "type",
                get: function() {
                    return "toggle_volume"
                }
            },
            {
                key: "props",
                get: function() {
                    return Object(de.a)(Object(de.a)({},
                    this._props), {},
                    {
                        eventString: "".concat(this._props.mode, ":toggle")
                    })
                }
            }]),
            n
        } (ze),
        Ge = n(191),
        Ke = n.n(Ge),
        Je = function() {
            function e(t) {
                Object(a.a)(this, e),
                this.messageEventIO = void 0,
                this.messageEventIO = t
            }
            return Object(r.a)(e, [{
                key: "onReceiveContentSet",
                value: function(t, n) {
                    this.onReceivedLocalizationData((function(a) {
                        n(Ke()(Object(de.a)({},
                        t), Object(de.a)(Object(de.a)({},
                        t), e.flattenTranslations(a))))
                    }))
                }
            },
            {
                key: "onReceivedLocalizationData",
                value: function(t) {
                    var n = this.messageEventIO.receivedMessageEvents().reduce((function(t, n) {
                        return e.messageEventIsLocalizationData(n) && (!t || t.timeStamp <= n.timeStamp) ? n: t
                    }), null);
                    n && t(n.data.event),
                    this.messageEventIO.onReceiveMessageEvent((function(n) {
                        e.messageEventIsLocalizationData(n) && t(n.data.event)
                    }))
                }
            }], [{
                key: "flattenTranslations",
                value: function(e) {
                    return e.translations && Array.isArray(e.translations) ? Object(de.a)(Object(de.a)({},
                    e), {},
                    {
                        translations: e.translations.reduce((function(e, t) {
                            return e[t.id] = t.name,
                            e
                        }), {})
                    }) : Object(de.a)({},
                    e)
                }
            },
            {
                key: "messageEventIsLocalizationData",
                value: function(e) {
                    return e.data && "localization-data" === e.data.type
                }
            }]),
            e
        } (),
        Ze = function() {
            function e() {
                Object(a.a)(this, e)
            }
            return Object(r.a)(e, null, [{
                key: "appIsEmbeddedInIframe",
                value: function() {
                    return window.location !== window.parent.location
                }
            }]),
            e
        } (),
        Qe = function() {
            function e() {
                Object(a.a)(this, e)
            }
            return Object(r.a)(e, null, [{
                key: "load",
                value: function(e, t) {
                    Ze.appIsEmbeddedInIframe() || t(e);
                    var n = new We(window);
                    n.sendMessageToParent({
                        type: "DebugMessage",
                        name: "DataStructure",
                        data: e
                    },
                    document.location.origin);
                    var a = new Je(n),
                    r = !1;
                    if (a.onReceiveContentSet(e, (function(e) {
                        r = !0,
                        t(e)
                    })), Ze.appIsEmbeddedInIframe()) {
                        window.setTimeout((function() {
                            r || (console.error("Could not detect localization-data after ".concat(5e3, " ms - using fallback data.")), t(e))
                        }), 5e3)
                    }
                }
            }]),
            e
        } (),
        /*$e = {
            translations: {
                title: "Play light bar",
                "long-text": "",
                "short-text": "",
                "call-to-action": "Turn syncing on or off",
                "crop-focus-x": .72,
                "crop-focus-y": .5,
                "fallback-image": "",
                "room1-start-image-1920": "https://www.docs.signify.com/hue/vr/meethue/Assets/start_1920.jpg",
                "room1-frame-780": "https://www.docs.signify.com/hue/vr/meethue/Assets/Obduction_PNG_780.png",
                "room1-frame-1020": "https://www.docs.signify.com/hue/vr/meethue/Assets/Obduction_PNG_1020.png",
                "room1-scene1-video-780": "https://www.docs.signify.com/hue/vr/meethue/Assets/Obduction_v2_780.mp4",
                "room1-scene1-video-1020": "https://www.docs.signify.com/hue/vr/meethue/Assets/Obduction_v2_1020.mp4"
            }
        },*/
        qe = function() {
            function e(t) {
                Object(a.a)(this, e),
                this._input = void 0,
                this._input = t
            }
            return Object(r.a)(e, [{
                key: "input",
                get: function() {
                    return this._input
                }
            },
            {
                key: "title",
                get: function() {
                    return this._input.translations.title
                }
            },
            {
                key: "shortText",
                get: function() {
                    return this._input.translations["short-text"]
                }
            },
            {
                key: "longText",
                get: function() {
                    return this._input.translations["long-text"]
                }
            },
            {
                key: "ctaText",
                get: function() {
                    return this._input.translations["call-to-action"]
                }
            },
            {
                key: "cropX",
                get: function() {
                    return this._input.translations["crop-focus-x"]
                }
            },
            {
                key: "cropY",
                get: function() {
                    return this._input.translations["crop-focus-y"]
                }
            },
            {
                key: "scenes",
                get: function() {
                    return [{
                        videoSources: [{
                            src: this._input.translations["room1-scene1-video-780"],
                            width: 780
                        },
                        {
                            src: this._input.translations["room1-scene1-video-1020"],
                            width: 1020
                        }]
                    }]
                }
            },
            {
                key: "room",
                get: function() {
                    return {
                        startImage: this._input.translations["room1-start-image-1920"],
                        frames: {
                            sources: [{
                                src: this._input.translations["room1-frame-780"],
                                width: 780
                            },
                            {
                                src: this._input.translations["room1-frame-1020"],
                                width: 1020
                            }]
                        },
                        scenes: this.scenes
                    }
                }
            }]),
            e
        } (),
        et = function(e) {
            Object(o.a)(n, e);
            var t = Object(i.a)(n);
            function n(e) {
                var r;
                return Object(a.a)(this, n),
                (r = t.call(this, e)).analytics = void 0,
                r.onTogglePaused = function() {
                    r.analytics.tag(new Ue({
                        mode: r.state.paused ? "play": "pause",
                        name: null === r.state.selectedSceneIndex ? "NoVideoActive": "Video".concat(r.state.selectedSceneIndex + 1)
                    })),
                    r.setState((function(e) {
                        return {
                            paused: !e.paused
                        }
                    }))
                },
                r.onToggleLightMi = function() {
                    r.analytics.tag(new Ye({
                        mode: r.state.lightMiEnabled ? "off": "on"
                    })),
                    r.setState((function(e) {
                        return e.untouched && !e.lightMiEnabled && r.onStart(0),
                        {
                            untouched: !1,
                            lightMiEnabled: !e.lightMiEnabled
                        }
                    }))
                },
                r.onToggleMuted = function() {
                    r.analytics.tag(new Xe({
                        mode: r.state.muted ? "on": "off"
                    })),
                    r.setState((function(e) {
                        return {
                            muted: !e.muted
                        }
                    }))
                },
                r.analytics = new He(new We(window)),
                r.state = {
                    untouched: !0,
                    prevSelectedSceneIndex: null,
                    selectedSceneIndex: null,
                    paused: !1,
                    lightMiEnabled: !1,
                    muted: !0,
                    input: e.input ? e.input: null
                },
                r
            }
            return Object(r.a)(n, [{
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    Qe.load($e, (function(t) {
                        e.setState({
                            input: t
                        })
                    }))
                }
            },
            {
                key: "onStart",
                value: function(e) {
                    if (e < 0 || e >= this.contentSet.scenes.length) throw new Error("Scene with index ".concat(e, " does not exist"));
                    this.analytics.tag(new Ue({
                        mode: "play",
                        name: "Video".concat(e + 1)
                    })),
                    this.setState((function(t) {
                        return {
                            untouched: !1,
                            prevSelectedSceneIndex: t.selectedSceneIndex,
                            selectedSceneIndex: e,
                            paused: !1,
                            lightMiEnabled: !0
                        }
                    }))
                }
            },
            {
                key: "videoSrcToLoad",
                value: function(e) {
                    var t = $.fromSources(e).firstPlayableSourceForWidth(window.innerWidth);
                    return t ? t.src: null
                }
            },
            {
                key: "getVideoState",
                value: function(e) {
                    return this.selectedScene ? e ? this.state.paused ? ve.Paused: ve.Playing: ve.Loading: ve.Stopped
                }
            },
            {
                key: "getVideoSrcToShow",
                value: function(e) {
                    return e ? this.selectedScene ? this.videoSrcToLoad(this.selectedScene.videoSources) : null: this.prevSelectedScene ? this.videoSrcToLoad(this.prevSelectedScene.videoSources) : null
                }
            },
            {
                key: "getMediaItemToShow",
                value: function(e) {
                    var t = this.getVideoSrcToShow(e);
                    return t ? {
                        id: t,
                        type: "video",
                        props: {
                            src: t
                        }
                    }: {
                        id: this.contentSet.room.startImage,
                        type: "image",
                        props: {
                            sources: [{
                                src: this.contentSet.room.startImage,
                                width: 1920
                            }]
                        }
                    }
                }
            },
            {
                key: "videoStateForSceneIndex",
                value: function(e, t) {
                    return this.state.selectedSceneIndex === t ? this.getVideoState(e) : ve.Stopped
                }
            },
            {
                key: "enableMuteButton",
                value: function(e) {
                    return ! this.isIOS || this.getHtmlVideoElementIsLoaded(e)
                }
            },
            {
                key: "getHtmlVideoElementIsLoaded",
                value: function(e) {
                    return "video" === this.getMediaItemToShow(e).type
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    if (null === this.state.input) return null;
                    var t = new qe(this.state.input);
                    return c.a.createElement(De, null, ee.debug && c.a.createElement(fe, null), this.useFallbackApplication ? c.a.createElement(le, {
                        title: t.title,
                        shortText: t.shortText,
                        longText: t.longText,
                        image: "" !== this.state.input.translations["fallback-image"] ? this.state.input.translations["fallback-image"] : this.state.input.translations["room1-start-image-1920"]
                    }) : c.a.createElement(d, {
                        videoSrc: this.currentSceneVideoSrc,
                        event: "canplaythrough",
                        render: function(t) {
                            return c.a.createElement(ue, {
                                visibility: X.Both,
                                settings: c.a.createElement("div", null, c.a.createElement(Q, {
                                    paused: e.state.paused,
                                    onToggle: e.onTogglePaused,
                                    enabled: e.enableMuteButton(t) && null !== e.state.selectedSceneIndex
                                }), c.a.createElement(N, {
                                    muted: e.state.muted,
                                    onToggle: e.onToggleMuted,
                                    enabled: e.enableMuteButton(t)
                                })),
                                header: c.a.createElement(b, {
                                    title: e.contentSet.title,
                                    shortText: e.contentSet.shortText,
                                    longText: e.contentSet.longText
                                }),
                                callToAction: c.a.createElement(_, {
                                    className: l.a.actionText,
                                    attractAttention: e.state.untouched
                                },
                                e.contentSet.ctaText),
                                interactionControl: c.a.createElement(Ae, {
                                    selectedSceneIndex: e.state.selectedSceneIndex,
                                    lightMiEnabled: e.state.lightMiEnabled,
                                    onToggleLightMi: e.onToggleLightMi,
                                    videoState: e.getVideoState(t)
                                }),
                                background: c.a.createElement(Le, {
                                    videoState: e.getVideoState(t),
                                    lightMiEnabled: e.state.lightMiEnabled || e.state.untouched,
                                    frames: e.contentSet.room.frames,
                                    mediaItem: e.getMediaItemToShow(t),
                                    muted: e.state.muted,
                                    cropX: e.contentSet.cropX,
                                    cropY: e.contentSet.cropY
                                })
                            })
                        }
                    }))
                }
            },
            {
                key: "contentSet",
                get: function() {
                    if (this.state.input) return new qe(this.state.input);
                    throw new Error("Input not loaded")
                }
            },
            {
                key: "selectedScene",
                get: function() {
                    return null === this.state.selectedSceneIndex ? null: this.contentSet.scenes[this.state.selectedSceneIndex]
                }
            },
            {
                key: "prevSelectedScene",
                get: function() {
                    return null === this.state.prevSelectedSceneIndex ? null: this.contentSet.scenes[this.state.prevSelectedSceneIndex]
                }
            },
            {
                key: "currentSceneVideoSrc",
                get: function() {
                    return this.selectedScene ? this.videoSrcToLoad(this.selectedScene.videoSources) : null
                }
            },
            {
                key: "isIOS",
                get: function() {
                    return !! navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
                }
            },
            {
                key: "useFallbackApplication",
                get: function() {
                    var e = !!te.find((function(e) {
                        return e(new q.UAParser)
                    }));
                    return ee.simulateUnsupportedBrowser || e
                }
            }]),
            n
        } (c.a.Component);
        t.
    default = et
    },
    392 : function(e, t, n) {
        "use strict";
        n.r(t);
        n(194),
        n(203);
        var a = n(0),
        r = n.n(a),
        o = n(186),
        i = n.n(o),
        s = (n(388), n(389), n(187));
        n.n(s).a.polyfill();
        var c = window,
        u = document.documentElement;
        c.__interactiveVisualizationDebug = {
            getDimensions: function() {
                var e = document.getElementById("interactive-visualization-instance");
                console.log("window.innerWidth: ".concat(window.innerWidth, "\n") + "window.innerHeight: ".concat(window.innerHeight, "\n") + "window.documentElement.clientWidth: ".concat(u.clientWidth, "\n") + "window.documentElement.clientHeight: ".concat(u.clientHeight, "\n") + "iframe offsetWidth: ".concat(e ? e.offsetWidth: "null", "\n") + "iframe offsetHeight: ".concat(e ? e.offsetHeight: "null"))
            }
        };
        var l = n(391).
    default;
        Boolean("localhost" === window.location.hostname || "[::1]" === window.location.hostname || window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
        i.a.render(r.a.createElement(l, null), document.getElementById("lightmi")),
        "serviceWorker" in navigator && navigator.serviceWorker.ready.then((function(e) {
            e.unregister()
        }))
    },
    40 : function(e, t, n) {
        e.exports = {
            fixIOSIssue: "textlayer_fixIOSIssue",
            "fix-ios-issue": "textlayer_fix-ios-issue",
            title: "textlayer_title",
            text: "textlayer_text",
            shortText: "textlayer_shortText",
            longText: "textlayer_longText"
        }
    },
    52 : function(e, t, n) {
        e.exports = {
            lightmiControl: "lightmi_Control",
            label: "lightmi_Control_label",
            title: "lightmi_Control_title",
            subtitle: "lightmi_Control_subtitle",
            subtitleDisabled: "lightmi_Control_subtitleDisabled",
            toggleContainer: "lightmi_Control_toggleContainer"
        }
    },
    73 : function(e, t, n) {
        e.exports = {
            container: "lightmi_Video_container",
            fadeIn: "lightmi_Video_fadeIn",
            "fade-in": "lightmi_Video_fade-in",
            lightMiLayer: "lightmi_Video_layer",
            lightMiLayerEnabled: "lightmi_Video_layerEnabled"
        }
    },
    90 : function(e, t, n) {
        e.exports = {
            container: "medialayer_container",
            mediaItem: "medialayer_mediaItem"
        }
    }
},
[[193, 1, 2]]]);